<template>
    <div>
        <div class="fw-gwitems">
            <van-tree-select
                    style="width: 100%"
                    :height="kdStyle"
                    :items="list"
                    :main-active-index.sync="activeIndex"
                    @click-nav="getItems"
                    v-if="list.length>0"
            >
                <template slot="content">
                    <div class="fw-gwitems-r">
                        <div class="fwgr-item" v-for="item in items">
                            <div class="fwgr-item-info">
                                <span class="mc">{{item.itemName}}</span>
                                <span class="jg">¥{{item.price}}</span>
                            </div>
                            <el-button size="mini" @click="toChoose(item)">选择</el-button>
                        </div>
                    </div>
                </template>
            </van-tree-select>
        </div>
        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{item.itemName}}</span>
                    <span class="jg">¥{{item.price}}</span>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">调整价格</span>
                        <el-input v-model="item.total" size="mini" placeholder="请输入价格" class="ki"></el-input>
                    </div>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                            <span class="empname" @click="setLEmp(emp,1)"
                                  @dblclick="setDEmp(emp,1)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(1)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(1)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                            <span class="empname" @click="setLEmp(emp,2)"
                                  @dblclick="setDEmp(emp,2)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(2)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(2)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                            <span class="empname" @click="setLEmp(emp,3)"
                                  @dblclick="setDEmp(emp,3)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(3)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(3)">点</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addData"> 确定</div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                activeIndex: 0,
                list:[],
                items:[],

                show: false,
                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',

                total:0,

                mc:{},
            };
        },
        props:{
            mbCard:Object,
            kdStyle:String
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            if (this.mbCard&&this.mbCard.id){
                this.mc=this.mbCard
            }
            this.getCatItems()
        },
        methods: {
            //切换会员卡
            qiehuan(mc){
                if (mc&&mc.id){
                    this.mc=mc
                }else {
                    this.mc={}
                }
            },
            async getCatItems() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getMdCatItems", data)
                this.list = res.list
                if (res.list.length > 0) {
                    this.items = res.list[0].items
                }
            },

            getItems(index) {
                this.items= this.list[index].items
            },

            toChoose(item) {
                this.show = true
                let newItem = JSON.parse(JSON.stringify(item))
                newItem.total = newItem.price
                //计算会员价格
                this.mcjiage(item,newItem)
                this.item = newItem
                this.getFwEmps()
            },

            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            addData() {
                let fEmp = {}
                let sEmp = {}
                let tEmp = {}
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.status != 0) {
                            fEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                gradeName: item.gradeName,
                                station: 1,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.status != 0) {
                            sEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                gradeName: item.gradeName,
                                station: 2,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.status != 0) {
                            tEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                gradeName: item.gradeName,
                                station: 3,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
               let item = this.item
               let newItem ={
                    itemId: item.id,
                    storeDeptId: item.storeDeptId,
                    itemName: item.itemName,
                    price: item.total,
                    first: item.first,
                    second: item.second,
                    third: item.third,
                    mdAch: 0,
                    kdAch: 0,
                    oglPrice: item.price,
                    oglCostPrice: item.costPrice,
                    add: 0,
                    cost: item.cost,
                    itemSign: 0,
                    discount: item.discount,
                    itemVips: item.itemVips,
                    noteId: '',
                    tjType: 0,
                    femp: fEmp,
                    semp: sEmp,
                    temp: tEmp,
                };
                var total = parseFloat(this.total) + parseFloat(item.total)
                this.total = total.toFixed(1)
                let data ={
                    item:newItem,
                    total:item.total
                }
                this.$emit('toItemChoose',data)
                this.show = false
            },

            async setLEmp(item, type) {
                this.setUnchecked(type);
                item.status = 1
            },

            async setDEmp(item, type) {
                this.setUnchecked(type);
                item.status = 2
            },

            // 将选中的人状态更改为没选中
            setUnchecked(type) {
                if (type == 1) {
                    this.changeEmpFalse(this.fEmps);
                }
                if (type == 2) {
                    this.changeEmpFalse(this.sEmps);
                }
                if (type == 3) {
                    this.changeEmpFalse(this.tEmps)
                }
            },
            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    if (item.status != 0) {
                        item.status = 0
                    }
                })
            },

            mcjiage(item,newItem){
                if (newItem.discount == 1) {
                    if (this.mc && this.mc.id) {
                        let vips=false
                        if (newItem.itemVips.length > 0) {
                            newItem.itemVips.forEach(vip => {
                                if (vip.cardId == this.mc.cardId) {
                                    newItem.total = vip.vipPrice;
                                    vips=true
                                }
                            })
                        }
                        if (!vips){
                            if (this.mbCard.itemDiscount > 0) {
                                newItem.total = this.calculationPrice(item.price, this.mc.itemDiscount)
                            }
                        }
                    }
                }
            },

            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
        },
    };
</script>

<style lang="scss" scoped>


</style>
